'use es6';

import { useCallback } from 'react';
import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIButton from 'UIComponents/button/UIButton';
import { push } from '../../utils/history';
import { getLoginUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const NoAccessError = ({
  use
}) => {
  const getI18nKey = useCallback(key => {
    return `appMarketplace.error.${use === 'preview' ? 'noPreviewAccess' : 'noAccess'}.${key}`;
  }, [use]);
  const handleButtonClick = useCallback(() => {
    if (use === 'preview') {
      window.location.href = getLoginUrl();
    } else {
      push('/');
    }
  }, [use]);
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "keys",
    title: unescapedText(getI18nKey('title')),
    children: /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-4",
      use: "tertiary",
      onClick: handleButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey('button')
      })
    })
  });
};
NoAccessError.propTypes = {
  use: PropTypes.oneOf(['default', 'preview'])
};
NoAccessError.defaultProps = {
  use: 'default'
};
export default NoAccessError;